/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import { StyledModalBox } from './styles';
import PackageNewEditForm from 'src/sections/@dashboard/package/PackageNewEditForm';
import { Package } from 'src/@types/package';

export const PackageModal = ({
  open,
  handleClose,
  isEdit,
  currentPackage,
}: {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentPackage: Package | undefined;
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledModalBox>
        <PackageNewEditForm
          handleClose={handleClose}
          isEdit={isEdit}
          currentPackage={currentPackage}
        />
      </StyledModalBox>
    </Modal>
  );
};
